import { render } from "./CalculatorBanner.vue?vue&type=template&id=0c459a41&scoped=true"
const script = {}

import "./CalculatorBanner.vue?vue&type=style&index=0&id=0c459a41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c459a41"]])

export default __exports__